/**
 * @generated SignedSource<<35b45a3269e81de48075c91a2740e980>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useHasUnpublishedRequestRestrictions_slot$data = {
  readonly __typename: "QueueSlot";
  readonly agenda: {
    readonly configuredRequestRestrictions: {
      readonly edges: ReadonlyArray<{
        readonly liftAt: string | null | undefined;
        readonly requestCloses: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  };
  readonly " $fragmentType": "useHasUnpublishedRequestRestrictions_slot";
} | {
  readonly __typename: "TimeSlot";
  readonly configuredRequestRestrictions: {
    readonly edges: ReadonlyArray<{
      readonly liftAt: string | null | undefined;
      readonly requestCloses: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useHasUnpublishedRequestRestrictions_slot";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "useHasUnpublishedRequestRestrictions_slot";
};
export type useHasUnpublishedRequestRestrictions_slot$key = {
  readonly " $data"?: useHasUnpublishedRequestRestrictions_slot$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHasUnpublishedRequestRestrictions_slot">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": [
      "REQUEST"
    ]
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "liftAt",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "requestCloses",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useHasUnpublishedRequestRestrictions_slot",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": "configuredRequestRestrictions",
              "args": (v0/*: any*/),
              "concreteType": "AgendaBookingRulesConnection",
              "kind": "LinkedField",
              "name": "requestWindowBookingRules",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AgendaBookingRulesEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": (v1/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "QueueSlot",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "configuredRequestRestrictions",
          "args": (v0/*: any*/),
          "concreteType": "SlotBookingRulesConnection",
          "kind": "LinkedField",
          "name": "requestWindowBookingRules",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SlotBookingRulesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
        }
      ],
      "type": "TimeSlot",
      "abstractKey": null
    }
  ],
  "type": "Slot",
  "abstractKey": "__isSlot"
};
})();

(node as any).hash = "dbd442e13a4b02add79a18afd1bb5b40";

export default node;
